import { EXPIRATION_PERIOD_OPTIONS } from 'domain/shared/newVacancy';

const DEFAULT_EXPIRATION_PERIOD_IN_MONTH = Object.keys(EXPIRATION_PERIOD_OPTIONS)[0] ?? '6';

export const getExpirationPeriodInMonth = (createdAt?: string | null, expirationDate?: string | null) => {
  if (!createdAt || !expirationDate) return DEFAULT_EXPIRATION_PERIOD_IN_MONTH;

  const expiration = new Date(expirationDate);
  const created = new Date(createdAt);

  if (Number.isNaN(expiration.getTime())) return DEFAULT_EXPIRATION_PERIOD_IN_MONTH;

  const monthDifference =
    (expiration.getFullYear() - created.getFullYear()) * 12 + (expiration.getMonth() - created.getMonth());

  const validPeriods = Object.keys(EXPIRATION_PERIOD_OPTIONS);
  const nearestPeriod = validPeriods.reduce((closest, current) => {
    const currentDifference = Math.abs(Number(current) - monthDifference);
    const closestDifference = Math.abs(Number(closest) - monthDifference);

    return currentDifference < closestDifference ? current : closest;
  }, validPeriods[0] ?? DEFAULT_EXPIRATION_PERIOD_IN_MONTH);

  return nearestPeriod;
};
